import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["label", "onClick", "className"];
import React from 'react';
import { useClassNameMapper } from './ThemeProvider';
var defaultProps = {
  label: 'Close'
};
var CloseButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classNames = useClassNameMapper();
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    type: "button",
    className: classNames('close', className),
    onClick: onClick
  }, props), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/React.createElement("span", {
    className: classNames('sr-only')
  }, label));
});
CloseButton.displayName = 'CloseButton';
CloseButton.defaultProps = defaultProps;
export default CloseButton;